/**
 * <cut-to-size-calculator>  (v2, per-lane pricing, October 2026)
 *
 * Price = market piece rate x area + a flat fee per piece, plus delivery
 * for the customer's lane (from the postal code or ZIP) inside one price,
 * lifted to a 30% floor and a break-even floor. The rules are the owner's
 * approved model in audits/calculator-audit-2026/calculator_v2_lanes.py;
 * the RATES block below is generated from it by theme/build_rates_v2.py.
 * Raw material costs, laser speeds and margins never appear here: the
 * floor coefficients k1/k2/kl are pre-divided and rescaled per lane.
 *
 * Circles are charged for the full square blank they are cut from; the
 * shipped weight stays on the actual circle.
 */
if (!customElements.get('cut-to-size-calculator')) {
  const s_cents_above = (el) => !!(el.state && el.priceMap && el.state.cents > el.maxInstantCents());

  customElements.define(
    'cut-to-size-calculator',
    class CutToSizeCalculator extends HTMLElement {
      connectedCallback() {
        /* RATES_V2:BEGIN (generated by theme/build_rates_v2.py; do not edit by hand) */
        this.RATES = {"version":"v2-lanes-2026-10-06","fee":3.99,"kl":2.2971,"kcard":0.4594,"d0":0.653,"fx":1.35,"maxInch":48,"maxQty":25,"pass":{"CA":0.968,"US":0.914},"margin":0.3,"reserve":{"standard":0.015,"oversize":0.03,"large":0.03,"freight":0.03},"xbBox":1.62,"box":{"S":[4.5,0.75],"M":[7.0,1.9],"L":[18.5,5.4],"crate":[60.0,12.0]},"kbox":{"S":6.8913,"M":10.7198,"L":28.3308,"crate":91.8836},"capLarge":{"CA":60,"US":90},"ca":{"ON/QC":{"name":"Ontario / Quebec","std":[12.75,0.55],"over":[30.0,0.4],"large":[55.0,0.25],"freight":350,"worst":{"std":[18.0,0.8],"over":36.0,"large":95.0,"freight":500}},"PRAIRIES":{"name":"MB / SK / AB","std":[18.5,1.2],"over":[50.0,0.6],"large":[85.0,0.5],"freight":450,"worst":{"std":[26.0,1.5],"over":72.0,"large":260.0,"freight":650}},"BC":{"name":"British Columbia","std":[20.0,1.3],"over":[55.0,0.6],"large":[110.0,0.5],"freight":500,"worst":{"std":[26.0,1.5],"over":72.0,"large":260.0,"freight":700}},"ATLANTIC":{"name":"NS / NB / NL / PE","std":[18.0,1.25],"over":[55.0,0.6],"large":[95.0,0.5],"freight":500,"worst":{"std":[26.0,1.5],"over":72.0,"large":260.0,"freight":700}},"REMOTE":{"name":"YT / NT / NU and beyond points","std":[45.0,2.5],"over":[130.0,1.0],"large":[260.0,0.5],"freight":900,"worst":{"std":[90.0,4.0],"over":200.0,"large":400.0,"freight":1200}}},"caOverlength":{"36":17.0,"44":30.0},"us":{"2":[7.09,0.462,7.1,254.5],"3":[7.09,0.462,7.11,274.5],"4":[7.48,0.501,7.12,274.5],"5":[8.42,0.648,8.05,320.5],"6":[8.63,0.888,9.13,320.5],"7":[8.9,1.046,9.41,331.0],"8":[9.9,1.223,10.0,331.0]},"usFreight":{"2":400,"3":420,"4":450,"5":480,"6":520,"7":560,"8":600},"usDas":0.43,"usRebillStd":0.086,"usRebillOver":30.0,"usAh":14.25,"usAhList":40.5,"usLpPeak":117.5,"materials":[{"id":"1mm Clear","family":"Clear acrylic","thick":"1mm","sort":0,"rate":5.49,"t":0.046875,"lb":0.00169,"k1":0.00821,"k2":0.0051},{"id":"2mm Clear","family":"Clear acrylic","thick":"2mm (5/64\")","sort":0,"rate":5.99,"t":0.079,"lb":0.00337,"k1":0.01026,"k2":0.00766},{"id":"3mm Clear","family":"Clear acrylic","thick":"3mm (1/8\")","sort":0,"rate":7.49,"t":0.125,"lb":0.00513,"k1":0.01761,"k2":0.01094},{"id":"4.5mm Clear","family":"Clear acrylic","thick":"4.5mm (3/16\")","sort":0,"rate":9.99,"t":0.18,"lb":0.00769,"k1":0.02634,"k2":0.01531},{"id":"6mm Clear","family":"Clear acrylic","thick":"6mm (1/4\")","sort":0,"rate":11.99,"t":0.25,"lb":0.01025,"k1":0.03522,"k2":0.02393},{"id":"9mm Clear","family":"Clear acrylic","thick":"9mm (3/8\")","sort":0,"rate":15.99,"t":0.375,"lb":0.01531,"k1":0.05283,"k2":0.0319},{"id":"12mm Clear","family":"Clear acrylic","thick":"12mm (1/2\")","sort":0,"rate":19.99,"t":0.5,"lb":0.02044,"k1":0.07044,"k2":0.06381},{"id":"3mm Colour","family":"Colour acrylic","thick":"3mm (1/8\")","sort":1,"rate":7.99,"t":0.125,"lb":0.00494,"k1":0.01899,"k2":0.01094},{"id":"6mm Colour","family":"Colour acrylic","thick":"6mm (1/4\")","sort":1,"rate":11.99,"t":0.25,"lb":0.00988,"k1":0.03323,"k2":0.02393},{"id":"3mm Transparents","family":"Transparent colour acrylic","thick":"3mm (1/8\")","sort":2,"rate":7.99,"t":0.125,"lb":0.00494,"k1":0.01899,"k2":0.01094},{"id":"3mm Mirror","family":"Mirror acrylic","thick":"3mm (1/8\")","sort":3,"rate":8.49,"t":0.125,"lb":0.0045,"k1":0.02129,"k2":0.01196},{"id":"3mm Frosted","family":"Frosted acrylic","thick":"3mm (1/8\")","sort":4,"rate":7.49,"t":0.125,"lb":0.0045,"k1":0.01531,"k2":0.01094},{"id":"6mm Frosted","family":"Frosted acrylic","thick":"6mm (1/4\")","sort":4,"rate":11.99,"t":0.25,"lb":0.00988,"k1":0.03063,"k2":0.02393},{"id":"3mm Grey/Frosted","family":"Grey frosted acrylic","thick":"3mm (1/8\")","sort":5,"rate":7.49,"t":0.125,"lb":0.0045,"k1":0.01562,"k2":0.01094},{"id":"6mm Grey/Frosted","family":"Grey frosted acrylic","thick":"6mm (1/4\")","sort":5,"rate":12.49,"t":0.25,"lb":0.00988,"k1":0.03813,"k2":0.02393},{"id":"3mm Glitter Colour","family":"Glitter acrylic","thick":"3mm (1/8\")","sort":6,"rate":8.49,"t":0.125,"lb":0.0045,"k1":0.02159,"k2":0.01094},{"id":"3mm Polycarbonate","family":"Polycarbonate","thick":"3mm (1/8\")","sort":7,"rate":6.99,"t":0.125,"lb":0.0045,"k1":0.01378,"k2":0.01094},{"id":"6mm Polycarbonate","family":"Polycarbonate","thick":"6mm (1/4\")","sort":7,"rate":9.99,"t":0.25,"lb":0.00988,"k1":0.02741,"k2":0.02393},{"id":"6mm Baltic Birch","family":"Baltic birch plywood","thick":"6mm (1/4\")","sort":8,"rate":5.49,"t":0.25,"lb":0.0065,"k1":0.00812,"k2":0.01823}]};
        /* RATES_V2:END */
        this.CLS = ['standard', 'oversize', 'large', 'freight'];
        this.CLS_LABEL = { standard: 'standard parcel', oversize: 'oversize parcel', large: 'large package', freight: 'freight shipment' };
        this.LANE_NAME = { 'ON/QC': 'Ontario / Quebec', PRAIRIES: 'Manitoba / Saskatchewan / Alberta', BC: 'British Columbia', ATLANTIC: 'Atlantic Canada', REMOTE: 'northern / remote Canada' };
        // USA: ZIP prefix ranges -> UPS zone from Sanborn NY (approximate; replace with the UPS chart when supplied).
        this.US_ZONES = [[10, 29, 4], [30, 38, 4], [39, 49, 4], [50, 59, 4], [60, 69, 4], [70, 89, 3], [100, 129, 3], [130, 149, 2], [150, 168, 2], [169, 196, 3],
          [197, 219, 4], [220, 246, 4], [247, 268, 3], [270, 289, 4], [290, 319, 5], [320, 329, 5], [330, 349, 6], [350, 369, 5], [370, 385, 4], [386, 397, 5],
          [400, 427, 4], [430, 439, 3], [440, 449, 2], [450, 459, 3], [460, 479, 3], [480, 499, 3], [500, 528, 5], [530, 549, 4], [550, 567, 5], [570, 588, 6],
          [590, 599, 7], [600, 629, 4], [630, 658, 5], [660, 693, 6], [700, 714, 6], [716, 729, 5], [730, 749, 6], [750, 797, 6], [798, 799, 7], [800, 816, 7],
          [820, 838, 7], [840, 847, 7], [850, 865, 8], [870, 884, 7], [889, 898, 8], [900, 961, 8], [970, 994, 8]];
        this.US_EXCLUDED = [[995, 999, 'Alaska'], [967, 968, 'Hawaii'], [6, 9, 'Puerto Rico and US territories']];
        this.CA_PROV = { A: 'ATLANTIC', B: 'ATLANTIC', C: 'ATLANTIC', E: 'ATLANTIC', G: 'ON/QC', H: 'ON/QC', J: 'ON/QC', K: 'ON/QC', L: 'ON/QC', M: 'ON/QC', N: 'ON/QC', P: 'ON/QC', R: 'PRAIRIES', S: 'PRAIRIES', T: 'PRAIRIES', V: 'BC', X: 'REMOTE', Y: 'REMOTE' };
        this.CA_REMOTE_FSA = ['A0P', 'A2V', 'X0A', 'X0B', 'X0C', 'X0E', 'X0G', 'Y0A', 'Y0B', 'V0N', 'V0P', 'V0T', 'V0V', 'V0W', 'R0B', 'T0P', 'T0V', 'S0J'];

        this.shape = 'rect';
        this.unit = 'in';
        this.$ = (ref) => this.querySelector(`[data-ctc="${ref}"]`);

        this.colours = {};
        try {
          const raw = JSON.parse(this.$('colours').textContent);
          Object.keys(raw).forEach((id) => {
            this.colours[id] = (raw[id] || []).map((c) => c.trim()).filter(Boolean);
          });
        } catch (e) {
          this.colours = {};
        }

        this.variants = null;
        const variantsEl = this.$('variants');
        if (variantsEl) {
          try {
            const list = JSON.parse(variantsEl.textContent);
            if (Array.isArray(list) && list.length) {
              this.variants = list
                .filter((v) => v && v.id)
                .map((v) => ({ id: v.id, label: (v.label || '').trim(), group: (v.group || '').trim(), colours: (v.colours || []).map((c) => c.trim()).filter(Boolean) }));
              this.variants.forEach((v) => {
                if (v.colours.length) this.colours[v.id] = v.colours;
              });
            }
          } catch (e) {
            this.variants = null;
          }
        }

        // Shopify Markets: the ladder product is priced in CAD; when the visitor's
        // market shows USD, Shopify converts at its daily rate and rounds up to a whole dollar.
        // We show the same figure so the price on the page is the price at checkout.
        const sc = window.Shopify && window.Shopify.currency;
        const rate = sc ? parseFloat(sc.rate) : NaN;
        this.usd = !!(sc && sc.active === 'USD' && rate > 0 && rate < 1.5);
        this.rate = this.usd ? rate : 1;

        this.priceMap = null;
        this.priceMapFailed = false;
        this.usdTable = null;   // variant id -> USD cents, as Shopify presents the ladder product
        this.usdEnding = null;  // cents ending of Shopify's USD rounding rule (0 = whole dollar, 99 = x.99)
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

        this.buildMaterialOptions();
        this.bindEvents();

        this.pendingColour = null;
        try {
          const wanted = new URLSearchParams(window.location.search).get('colour');
          if (wanted) this.pendingColour = wanted.trim().toLowerCase();
        } catch (e) {
          this.pendingColour = null;
        }
        try {
          const params = new URLSearchParams(window.location.search);
          const parts = (params.get('size') || '').toLowerCase().split(/[x×*]/);
          if (parts.length === 2 && this.parseDim(parts[0]) > 0 && this.parseDim(parts[1]) > 0) {
            if (params.get('unit') === 'cm') {
              const cm = this.querySelector('[data-unit="cm"]');
              if (cm) cm.click();
            }
            this.$('w').value = parts[0].trim();
            this.$('h').value = parts[1].trim();
          }
        } catch (e) {
          /* ignore malformed params */
        }

        // Postal code: remembered for the session; otherwise seeded from the
        // storefront's localization country (Canada by default).
        try {
          const saved = sessionStorage.getItem('ctc-postal');
          if (saved) this.$('postal').value = saved;
        } catch (e) {
          /* storage unavailable */
        }

        this.renderSizeHint();
        this.syncColours();
        this.syncShape();
        this.calc();
        this.loadPriceMap();
        this.loadUsdTable();
        this.syncPostalGate();
      }

      loadPriceMap() {
        const url = this.dataset.priceMap;
        if (!url) {
          this.priceMapFailed = true;
          this.updateBuyState();
          return;
        }
        fetch(url)
          .then((r) => (r.ok ? r.json() : Promise.reject(new Error(r.status))))
          .then((map) => {
            if (!map || !Array.isArray(map.ids) || !map.ids.length) throw new Error('empty map');
            this.priceMap = map;
          })
          .catch(() => {
            this.priceMapFailed = true;
          })
          .finally(() => this.updateBuyState());
      }

      /** In a USD session, read the ladder product's presented prices so the page shows exactly
       *  what checkout charges, whatever rounding rule the United States market uses. The product
       *  endpoint returns the first 250 price points; above that the rule is applied by hand. */
      loadUsdTable() {
        const url = this.dataset.ladderUrl;
        if (!this.usd || !url) return;
        fetch(url)
          .then((r) => (r.ok ? r.json() : Promise.reject(new Error(r.status))))
          .then((product) => {
            const table = {};
            (product.variants || []).forEach((v) => {
              if (v && v.id && typeof v.price === 'number') table[v.id] = v.price;
            });
            const first = (product.variants || [])[0];
            if (first && typeof first.price === 'number') this.usdEnding = first.price % 100;
            this.usdTable = table;
            if (this.state) this.calc();
          })
          .catch(() => {});
      }

      /** Price ladder tiers: $1 steps to $1,004.99, then $5 steps to $4,999.99 (the online checkout cap). */
      tiers() {
        const m = this.priceMap;
        if (!m) return [];
        return [{ start: m.start, step: m.step, ids: m.ids }].concat(Array.isArray(m.tiers) ? m.tiers : []);
      }

      maxInstantCents() {
        const t = this.tiers();
        if (!t.length) return 0;
        const last = t[t.length - 1];
        return last.start + (last.ids.length - 1) * last.step;
      }

      variantIdFor(cents) {
        for (const t of this.tiers()) {
          const offset = cents - t.start;
          if (offset < 0 || offset % t.step !== 0) continue;
          const id = t.ids[offset / t.step];
          if (id) return id;
        }
        return null;
      }

      syncColours() {
        const field = this.$('colour-field');
        const select = this.$('colour');
        const list = this.colours[this.$('mat').value] || [];
        if (!list.length) {
          field.hidden = true;
          select.innerHTML = '';
          return;
        }
        const previous = select.value;
        select.innerHTML = '';
        list.forEach((name) => {
          const option = document.createElement('option');
          option.value = name;
          option.textContent = name;
          select.appendChild(option);
        });
        if (list.includes(previous)) select.value = previous;
        if (this.pendingColour) {
          const hit = list.filter((name) => name.toLowerCase() === this.pendingColour)[0];
          if (hit) select.value = hit;
          this.pendingColour = null;
        }
        field.hidden = false;
      }

      colour() {
        return this.$('colour-field').hidden ? '' : this.$('colour').value;
      }

      /** Polycarbonate is cut in straight lines only: no circle option for it. */
      circleAllowed() {
        const m = this.mat();
        return !(m && m.family === 'Polycarbonate');
      }

      syncShape() {
        const circleBtn = this.querySelector('[data-shape="circle"]');
        if (!circleBtn) return;
        const allowed = this.circleAllowed();
        circleBtn.hidden = !allowed;
        circleBtn.setAttribute('aria-disabled', String(!allowed));
        if (!allowed && this.shape === 'circle') {
          this.shape = 'rect';
          this.querySelectorAll('[data-shape]').forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.shape === 'rect')));
          this.$('rect-fields').style.display = 'grid';
          this.$('circle-fields').style.display = 'none';
          this.renderSizeHint();
        }
      }

      buildMaterialOptions() {
        const select = this.$('mat');
        if (this.variants) {
          this.variants.forEach((v) => {
            const m = this.RATES.materials.filter((x) => x.id === v.id)[0];
            if (!m) return;
            const option = document.createElement('option');
            option.value = m.id;
            option.textContent = `${m.family} — ${m.thick}`;
            select.appendChild(option);
          });
          this.variants = this.variants.filter((v) => this.RATES.materials.some((m) => m.id === v.id));
          if (this.variants.length) {
            select.value = this.variants[0].id;
            this.buildFixedControls();
            return;
          }
          this.variants = null;
          this.$('mat-field').hidden = false;
        }
        const families = {};
        this.RATES.materials.forEach((m) => {
          (families[m.family] = families[m.family] || []).push(m);
        });
        Object.keys(families).forEach((family) => {
          const optgroup = document.createElement('optgroup');
          optgroup.label = family;
          families[family].forEach((m) => {
            const option = document.createElement('option');
            option.value = m.id;
            option.textContent = `${family} — ${m.thick}`;
            optgroup.appendChild(option);
          });
          select.appendChild(optgroup);
        });
        select.value = '3mm Clear';
      }

      buildFixedControls() {
        const groups = [];
        this.variants.forEach((v) => {
          if (v.group && !groups.includes(v.group)) groups.push(v.group);
        });
        this.currentGroup = groups[0] || '';
        const groupsEl = this.$('groups');
        if (groups.length > 1) {
          groupsEl.innerHTML = '';
          groups.forEach((g) => {
            const button = document.createElement('button');
            button.type = 'button';
            button.textContent = g;
            button.setAttribute('aria-pressed', String(g === this.currentGroup));
            button.addEventListener('click', () => {
              this.currentGroup = g;
              groupsEl.querySelectorAll('button').forEach((b) => b.setAttribute('aria-pressed', String(b === button)));
              this.renderThicknesses(true);
            });
            groupsEl.appendChild(button);
          });
          this.$('group-field').hidden = false;
        }
        this.renderThicknesses(false);
      }

      renderThicknesses(live) {
        const list = this.variants.filter((v) => v.group === this.currentGroup);
        const el = this.$('thicks');
        const current = this.variants.find((v) => v.id === this.$('mat').value);
        let target = list.find((v) => current && v.id === current.id);
        if (!target && current) target = list.find((v) => v.label && v.label === current.label);
        if (!target) target = list[0];
        el.innerHTML = '';
        list.forEach((v) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.textContent = v.label || v.id;
          button.dataset.variant = v.id;
          button.setAttribute('aria-pressed', String(v === target));
          button.addEventListener('click', () => this.selectVariant(v.id, true));
          el.appendChild(button);
        });
        this.$('thick-field').hidden = list.length < 2;
        if (target) this.selectVariant(target.id, live);
      }

      selectVariant(id, live) {
        this.$('mat').value = id;
        this.$('thicks')
          .querySelectorAll('button')
          .forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.variant === id)));
        if (live) {
          this.syncColours();
          this.syncShape();
          this.calc();
        }
      }

      bindEvents() {
        this.querySelectorAll('[data-shape]').forEach((button) => {
          button.addEventListener('click', () => {
            if (button.dataset.shape === 'circle' && !this.circleAllowed()) return;
            this.shape = button.dataset.shape;
            this.querySelectorAll('[data-shape]').forEach((b) => b.setAttribute('aria-pressed', b === button));
            this.$('rect-fields').style.display = this.shape === 'rect' ? 'grid' : 'none';
            this.$('circle-fields').style.display = this.shape === 'circle' ? 'block' : 'none';
            this.renderSizeHint();
            this.calc();
          });
        });

        this.querySelectorAll('[data-unit]').forEach((button) => {
          button.addEventListener('click', () => {
            const old = this.unit;
            this.unit = button.dataset.unit;
            this.querySelectorAll('[data-unit]').forEach((b) => b.setAttribute('aria-pressed', b === button));
            [this.$('w'), this.$('h'), this.$('d')].forEach((input) => {
              const v = this.parseDim(input.value) || 0;
              if (old !== this.unit && v) {
                input.value = this.unit === 'cm' ? this.cmText(v * 2.54) : this.fraction(v / 2.54);
              }
            });
            this.renderSizeHint();
            this.calc();
          });
        });

        [this.$('mat'), this.$('w'), this.$('h'), this.$('d'), this.$('qty'), this.$('colour'), this.$('postal')].forEach((el) => {
          el.addEventListener('input', () => { this._touched = true; this.calc(); });
          el.addEventListener('change', () => { this._touched = true; this.calc(); });
        });
        this.querySelectorAll('[data-shape], [data-variant], [data-group], [data-unit]').forEach((b) => b.addEventListener('click', () => { this._touched = true; }));
        this.$('mat').addEventListener('change', () => {
          this.syncColours();
          this.syncShape();
          this.calc();
        });
        this.$('postal').addEventListener('input', () => {
          this.syncPostalGate();
          try {
            sessionStorage.setItem('ctc-postal', this.$('postal').value);
          } catch (e) {
            /* storage unavailable */
          }
        });

        this.$('add').addEventListener('click', () => this.addToCart());

        this.$('open-quote').addEventListener('click', (event) => {
          const form = this.$('quote');
          const open = form.classList.toggle('open');
          event.currentTarget.setAttribute('aria-expanded', String(open));
          if (open) {
            this.$('name').focus();
            this.track('quote_opened', { above_cap: s_cents_above(this) });
          }
        });
        this.$('quote').addEventListener('submit', () => this.track('quote_sent', { above_cap: s_cents_above(this) }));
      }

      /** Analytics: published as Shopify custom events (Settings > Customer events > custom pixel can
       *  forward them to GA4 or Meta) and to gtag/dataLayer when present. No personal data. */
      track(name, extra) {
        const s = this.state || {};
        const lane = s.lane || {};
        const priceBand = (c) => (!c ? '' : c < 5000 ? 'under 50' : c < 10000 ? '50-100' : c < 25000 ? '100-250' : c < 50000 ? '250-500' : c < 100000 ? '500-1000' : '1000+');
        const data = Object.assign({
          material: s.material ? s.material.id : '',
          shape: this.shape || '',
          size: s.sizeText || '',
          pieces: s.q || 0,
          country: lane.country || '',
          lane: lane.lane != null ? String(lane.lane) : (lane.excluded ? 'excluded' : ''),
          price_band_cad: priceBand(s.cents),
          currency: this.cur(),
          calc_version: this.RATES.version,
        }, extra || {});
        try {
          if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
            window.Shopify.analytics.publish('ctc_' + name, data);
          }
        } catch (e) { /* analytics must never break pricing */ }
        try {
          if (typeof window.gtag === 'function') window.gtag('event', 'ctc_' + name, data);
          else if (Array.isArray(window.dataLayer)) window.dataLayer.push(Object.assign({ event: 'ctc_' + name }, data));
        } catch (e) { /* ignore */ }
      }

      /** Width, height and diameter stay locked until a usable postal code or ZIP is entered. */
      syncPostalGate() {
        const lane = this.lane(this.$('postal').value);
        this._gated = !(lane && !lane.excluded);
        ['w', 'h', 'd'].forEach((n) => {
          const i = this.$(n);
          if (!i) return;
          i.disabled = this._gated;
          if (this._gated) i.dataset.ph = i.dataset.ph || i.placeholder;
          i.placeholder = this._gated ? 'Postal code first' : (i.dataset.ph || '');
        });
        this.renderSizeHint();
      }

      renderSizeHint() {
        const hint = this.$('size-hint');
        if (!hint) return;
        hint.textContent = this._gated ? 'Enter your delivery postal code or ZIP above, then the size.' : this.sizeHint();
      }

      setStatus(text, tone) {
        const el = this.$('status');
        el.textContent = text || '';
        el.classList.toggle('ctc__status--error', tone === 'error');
        el.classList.toggle('ctc__status--ok', tone === 'ok');
      }

      updateBuyState() {
        const button = this.$('add');
        const s = this.state || {};
        let reason = '';
        let disabled = true;
        if (s.priceUnreliable) {
          // The warning box above the button already says why there's no price.
        } else if (this.priceMapFailed) {
          reason = 'Online checkout is unavailable right now. Request a quote and we’ll send a link to pay.';
        } else if (!this.priceMap) {
          // Price list still loading.
        } else if (s.cents > this.maxInstantCents()) {
          reason = `This price is above our online checkout limit of ${this.money(this.shownCents(this.maxInstantCents()) / 100)} ${this.cur()}. Send the request and we’ll email a link to pay the price shown.`;
        } else if (!this.variantIdFor(s.cents)) {
          reason = 'This price isn’t available for instant checkout. Request a quote instead.';
        } else {
          disabled = false;
        }
        button.setAttribute('aria-disabled', String(disabled));
        button.classList.toggle('ctc__btn--disabled', disabled);
        if (!this.adding) this.setStatus(reason);
      }

      lineProperties() {
        const s = this.state;
        const m = s.material;
        const props = { Material: `${m.family}, ${m.thick}` };
        const colour = this.colour();
        if (colour) props.Colour = colour;
        props.Shape = this.shape === 'circle' ? 'Circle' : 'Rectangle';
        props.Size = s.sizeText;
        props.Pieces = String(s.q);
        props['Must ship to'] = s.lane.label;
        props.Packaging = s.planText;
        props._ship_to = s.lane.country + ':' + s.lane.label;
        props._lane = String(s.lane.lane);
        props._class = s.cls;
        props._calc_version = this.RATES.version;
        return props;
      }

      addToCart() {
        const button = this.$('add');
        if (button.getAttribute('aria-disabled') === 'true' || this.adding) return;
        const s = this.state;
        const variantId = this.variantIdFor(s.cents);
        if (!variantId) {
          this.updateBuyState();
          return;
        }
        this.adding = true;
        button.classList.add('loading');
        this.$('add-spinner').hidden = false;
        this.setStatus('Adding…');

        const body = { id: variantId, quantity: 1, properties: this.lineProperties() };
        if (this.cart) {
          body.sections = this.cart.getSectionsToRender().map((section) => section.id);
          body.sections_url = window.location.pathname;
          this.cart.setActiveElement(document.activeElement);
        }
        const config = fetchConfig('javascript');
        config.body = JSON.stringify(body);

        fetch(window.routes.cart_add_url, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              throw new Error(response.description || response.message || 'Could not add to cart.');
            }
            const expected = this.shownCents(s.cents);
            const tolerance = this.usd ? 100 : 0;
            if (typeof response.price === 'number' && Math.abs(response.price - expected) > tolerance) {
              return fetch(window.routes.cart_change_url, {
                ...fetchConfig('javascript'),
                body: JSON.stringify({ id: response.key, quantity: 0 }),
              }).then(() => {
                throw new Error('The online price list is out of date. Request a quote and we’ll send a link to pay.');
              });
            }
            if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cut-to-size-calculator', productVariantId: variantId, cartData: response });
            }
            if (this.cart) {
              this.cart.renderContents(response);
              if (this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            } else {
              window.location = window.routes.cart_url;
              return;
            }
            this.setStatus('Added to cart.', 'ok');
            this.track('add_to_cart');
          })
          .catch((error) => {
            let message = error.message || 'Could not add to cart. Please try again.';
            if (/cannot find variant/i.test(message)) {
              message = 'Online checkout for cut-to-size isn’t switched on yet. Request a quote and we’ll send a link to pay.';
            }
            this.setStatus(message, 'error');
          })
          .finally(() => {
            this.adding = false;
            button.classList.remove('loading');
            this.$('add-spinner').hidden = true;
          });
      }

      mat() {
        return this.RATES.materials.filter((m) => m.id === this.$('mat').value)[0];
      }

      parseDim(raw) {
        let s = String(raw == null ? '' : raw)
          .trim()
          .toLowerCase()
          .replace(/[”"']|in(ch(es)?)?\b|cm\b|mm\b/g, '')
          .replace(/,/g, '.')
          .replace(/[¼½¾⅛⅜⅝⅞]/g, (ch) => ' ' + { '¼': '1/4', '½': '1/2', '¾': '3/4', '⅛': '1/8', '⅜': '3/8', '⅝': '5/8', '⅞': '7/8' }[ch])
          .replace(/\s+/g, ' ')
          .trim();
        if (!s) return 0;
        const match = s.match(/^(\d+\.?\d*|\.\d+)?(?:[\s\-+]*(\d+)\s*\/\s*(\d+))?$/);
        if (!match || (match[1] === undefined && match[2] === undefined)) return NaN;
        const whole = match[1] ? parseFloat(match[1]) : 0;
        if (match[2] === undefined) return whole;
        const num = parseInt(match[2], 10);
        const den = parseInt(match[3], 10);
        if (!den) return NaN;
        return whole + num / den;
      }

      sizeHint() {
        const base =
          this.unit === 'cm'
            ? 'Up to 122 × 122 cm. Decimals are fine, e.g. 30.13.'
            : 'Up to 48 × 48 inches, in 1/8" steps: 12 1/2, 12 3/8, 12.75. No extra charge for fractions.';
        return this.shape === 'circle' ? base + ' Circles are priced on the square sheet they are cut from.' : base;
      }

      sizeError(raw) {
        if (String(raw).trim() === '') return '';
        const v = this.parseDim(raw);
        if (isNaN(v)) return 'Couldn’t read that size. Try a decimal like 12.5 or a fraction like 12 1/2.';
        if (this.unit === 'cm') return '';
        const eighths = v * 8;
        if (Math.abs(eighths - Math.round(eighths)) < 1e-9) return '';
        const below = Math.floor(eighths) / 8;
        const above = Math.ceil(eighths) / 8;
        return `Inch sizes go in 1/8" steps. Try ${this.fraction(below)} or ${this.fraction(above)}, or switch to cm for an exact size.`;
      }

      fraction(v) {
        const eighths = Math.round(v * 8);
        const whole = Math.floor(eighths / 8);
        let num = eighths % 8;
        if (!num) return String(whole);
        let den = 8;
        while (num % 2 === 0) {
          num /= 2;
          den /= 2;
        }
        return (whole ? whole + ' ' : '') + num + '/' + den;
      }

      cmText(v) {
        return String(Math.round(v * 100) / 100);
      }

      toIn(v) {
        v = this.parseDim(v) || 0;
        if (this.unit === 'cm') return Math.round(v * 100) / 100 / 2.54;
        return v;
      }

      money(v) {
        return '$' + v.toFixed(2);
      }

      /** CAD cents -> USD cents the way Shopify presents them. Exact from the ladder table when
       *  the price point is in it; otherwise the daily rate rounded up to the market's rule
       *  ending (Shopify rounds converted prices up: C$20 x 1.3 x 1.2 = 31.20 -> 31.99 under .99). */
      usdCents(cadCents) {
        const id = this.variantIdFor(cadCents);
        if (id && this.usdTable && typeof this.usdTable[id] === 'number') return this.usdTable[id];
        const raw = cadCents * this.rate;
        const end = this.usdEnding == null ? 0 : this.usdEnding;
        return Math.max(100 + end, Math.ceil((raw - end) / 100 - 1e-9) * 100 + end);
      }

      /** Cents in the currency the visitor is shown, from the CAD price point. */
      shownCents(cadCents) {
        return this.usd ? this.usdCents(cadCents) : cadCents;
      }

      cur() {
        return this.usd ? 'USD' : 'CAD';
      }

      fmt(v) {
        return this.unit === 'cm' ? this.cmText(v * 2.54) + ' cm' : this.fraction(v) + '"';
      }

      /** Postal code or ZIP -> lane, or null when it can't be read. */
      lane(postal) {
        const p = String(postal || '').toUpperCase().replace(/\s+/g, '');
        if (/^[A-Z]\d[A-Z]/.test(p)) {
          const fsa = p.slice(0, 3);
          // Nunavut (X0A, X0B, X0C) is outside the Canada shipping zone (owner decision 2026-10-06).
          if (fsa === 'X0A' || fsa === 'X0B' || fsa === 'X0C') return { country: 'CA', excluded: 'Nunavut', label: fsa };
          const l = this.CA_REMOTE_FSA.includes(fsa) ? 'REMOTE' : this.CA_PROV[fsa[0]];
          return l ? { country: 'CA', lane: l, label: fsa, name: this.LANE_NAME[l] } : null;
        }
        if (/^\d{5}/.test(p)) {
          const z3 = parseInt(p.slice(0, 3), 10);
          for (const [a, b, name] of this.US_EXCLUDED) if (z3 >= a && z3 <= b) return { country: 'US', excluded: name, label: p.slice(0, 5) };
          for (const [a, b, z] of this.US_ZONES) if (z3 >= a && z3 <= b) return { country: 'US', lane: z, label: p.slice(0, 5), name: 'USA, zone ' + z };
          return { country: 'US', lane: 8, label: p.slice(0, 5), name: 'USA, zone 8' };
        }
        return null;
      }

      ladder(x) {
        if (x <= 1004.99) {
          const c = Math.floor(x) + 0.99;
          return c >= x - 1e-9 ? c : c + 1;
        }
        if (x <= 4999.99) {
          const c = Math.floor(x / 5) * 5 + 4.99;
          return c >= x - 1e-9 ? c : c + 5;
        }
        const c = Math.floor(x / 25) * 25 + 24.99;
        return c >= x - 1e-9 ? c : c + 25;
      }

      /** Box plan for q pieces of L x W (inches, L >= W): pads, stacking, splitting, carrier class. */
      planBoxes(m, L, W, q, country) {
        const R = this.RATES;
        const pieceLb = L * W * m.lb;
        const pad = L <= 24 ? 2 : 1;
        const classify = (n) => {
          const bl = Math.ceil(L + 2 * pad);
          const bw = Math.ceil(W + 2 * pad);
          const bh = Math.ceil(n * m.t + 1);
          const boxclass = bl <= 16 ? 'S' : bl <= 30 ? 'M' : bl <= 52 ? 'L' : 'crate';
          const gross = n * pieceLb + R.box[boxclass][1];
          const G = bl + 2 * (bw + bh);
          let cls;
          if (bl <= 48 && bw <= 30 && G <= 105 && gross <= 50) cls = 'standard';
          else if (G <= 130 && bl <= 96 && gross <= 50) cls = 'oversize';
          else if (G <= 165 && bl <= 108 && gross <= R.capLarge[country]) cls = 'large';
          else cls = 'freight';
          return { n, bl, bw, bh, gross, cls, boxclass };
        };
        const single = classify(1);
        const cap = { standard: 46, oversize: 46, large: R.capLarge[country], freight: 500 }[single.cls];
        let n = Math.max(1, Math.min(q, Math.floor((cap - R.box[single.boxclass][1]) / Math.max(pieceLb, 0.01))));
        while (n > 1 && this.CLS.indexOf(classify(n).cls) > this.CLS.indexOf(single.cls)) n -= 1;
        const nb = Math.ceil(q / n);
        const base = Math.floor(q / nb);
        const extra = q % nb;
        const boxes = [];
        for (let i = 0; i < nb; i++) boxes.push(classify(base + (i < extra ? 1 : 0)));
        return boxes;
      }

      billable(b, country) {
        const vol = b.bl * b.bw * b.bh;
        const dim = vol > 1728 ? vol / (country === 'CA' ? 139 : 166) : 0;
        const w = Math.max(b.gross, dim);
        return country === 'US' ? Math.ceil(w) : w;
      }

      /** [allowance, worst label] in CAD for one box on this lane. */
      allowance(lane, b) {
        const R = this.RATES;
        const w = this.billable(b, lane.country);
        const cls = b.cls;
        if (lane.country === 'CA') {
          const Lz = R.ca[lane.lane];
          if (cls === 'standard') {
            const extra = b.bl > 44 ? R.caOverlength['44'] : b.bl > 36 ? R.caOverlength['36'] : 0;
            return [Lz.std[0] + Lz.std[1] * w + extra, Lz.worst.std[0] + Lz.worst.std[1] * w + extra];
          }
          if (cls === 'oversize') return [Lz.over[0] + Lz.over[1] * w, Lz.worst.over + 0.8 * w];
          if (cls === 'large') return [Lz.large[0] + Lz.large[1] * w, Lz.worst.large + 0.5 * w];
          return [Lz.freight + Math.max(0, w - 100), Lz.worst.freight + Math.max(0, w - 100)];
        }
        const [a0, s, one, lp] = R.us[String(lane.lane)];
        const fx = R.fx;
        if (cls === 'standard') {
          const usd = (w <= 1 ? one : a0 + s * w) + R.usDas;
          return [usd * (1 + R.usRebillStd) * fx, (usd * 1.15 + 2) * fx];
        }
        if (cls === 'oversize') {
          const usd = a0 + s * Math.max(w, 40) + R.usAh + R.usDas;
          return [(usd + R.usRebillOver) * fx, (a0 + s * Math.max(w, 40) + R.usAhList + R.usDas + 8.75) * fx];
        }
        if (cls === 'large') {
          const usd = a0 + s * Math.max(w, 90) + lp + R.usDas;
          return [(usd + R.usRebillOver) * fx, (usd + R.usLpPeak) * fx];
        }
        const usd = R.usFreight[String(lane.lane)] + Math.max(0, w - 100);
        return [usd * fx, (usd + 150) * fx];
      }

      calc() {
        const R = this.RATES;
        const m = this.mat();
        const qRaw = parseInt(this.$('qty').value, 10) || 1;
        const q = Math.min(R.maxQty, Math.max(1, qRaw));
        let L, W, area, cut;
        if (this.shape === 'circle') {
          L = W = this.toIn(this.$('d').value);
          area = Math.PI * Math.pow(L / 2, 2);
          cut = Math.PI * L;
        } else {
          L = this.toIn(this.$('w').value);
          W = this.toIn(this.$('h').value);
          area = L * W;
          cut = 2 * (L + W);
        }
        const blank = L * W;
        const lng = Math.max(L, W);
        const sht = Math.min(L, W);

        let warn = '';
        let priceUnreliable = false;
        const activeFields = this.shape === 'circle' ? [this.$('d')] : [this.$('w'), this.$('h')];
        let sizeError = '';
        activeFields.forEach((input) => {
          const error = this.sizeError(input.value);
          input.setAttribute('aria-invalid', String(Boolean(error)));
          if (error && !sizeError) sizeError = error;
        });
        const lane = this.lane(this.$('postal').value);
        if (sizeError) {
          warn = sizeError;
          priceUnreliable = true;
        } else if (!L || !W) {
          warn = 'Enter a size to see a price.';
          priceUnreliable = true;
        } else if (lng > R.maxInch) {
          warn = `${R.maxInch} × ${R.maxInch} inches is the largest piece we cut.`;
          priceUnreliable = true;
        } else if (!lane) {
          warn = 'Enter your postal code or ZIP to see the delivered price.';
          priceUnreliable = true;
        } else if (lane.excluded) {
          warn = `We don’t ship to ${lane.excluded} yet.`;
          priceUnreliable = true;
        }
        if (qRaw > R.maxQty) warn = warn || `Up to ${R.maxQty} pieces per line; add another line for more.`;

        let price = 0;
        let cls = 'standard';
        let boxes = [];
        let planText = '';
        if (!priceUnreliable) {
          const pieces = q * ((blank / 144) * m.rate + R.fee);
          boxes = this.planBoxes(m, lng, sht, q, lane.country);
          const boxCost = boxes.reduce((t, b) => t + R.box[b.boxclass][0], 0);
          const kbox = boxes.reduce((t, b) => t + R.kbox[b.boxclass], 0);
          let allow = 0;
          let worst = 0;
          boxes.forEach((b) => {
            const [a, wo] = this.allowance(lane, b);
            allow += a;
            worst += wo;
          });
          const xb = lane.country === 'US' ? R.xbBox * boxes.length : 0;
          cls = boxes.reduce((c, b) => (this.CLS.indexOf(b.cls) > this.CLS.indexOf(c) ? b.cls : c), 'standard');
          const res = R.reserve[cls];
          const pas = R.pass[lane.country];
          const market = pieces + (boxCost + allow + xb) / pas;
          // Floors: pre-divided cost coefficients (by d0) rescaled to this lane's divisor.
          const costPre = (m.k1 * blank + m.k2 * cut + R.kl) * q + kbox + R.kcard + xb / R.d0;
          const dT = pas - R.margin - res;
          const dB = pas - res;
          const target = (costPre * R.d0 + allow) / dT;
          const breakeven = (costPre * R.d0 + worst) / dB;
          price = this.ladder(Math.max(market, target, breakeven));
          planText = boxes.length + (boxes.length > 1 ? ' boxes' : ' box') + ', ' + this.CLS_LABEL[cls];
        }
        const each = q ? price / q : 0;
        const lb = area * m.lb * q;

        const dims = this.shape === 'circle' ? this.fmt(L) + ' diameter' : this.fmt(L) + ' × ' + this.fmt(W);
        const colour = this.colour();
        this.$('desc').textContent = m.family + ', ' + m.thick.split(' ')[0] + (colour ? ', ' + colour.toLowerCase() : '') + ', ' + dims;
        this.$('qty-out').textContent = q;
        const sizeText = dims;
        const laneLabel = lane && !lane.excluded ? lane.label + ' (' + lane.name + ')' : '';

        this.state = { material: m, q, each, packR: price, cents: Math.round(price * 100), priceUnreliable, warn, sizeText, lane, laneLabel, cls, planText };

        clearTimeout(this._trackTimer);
        this._trackTimer = setTimeout(() => {
          if (!this._touched) return; // nothing to report until the visitor uses the calculator
          const key = [m.id, sizeText, q, lane ? lane.label : '', priceUnreliable].join('|');
          if (key === this._trackedKey) return;
          this._trackedKey = key;
          if (!lane) {
            // once per visit: it means "used the calculator without a postal code", not every keystroke
            if (!this._noPostalSent) { this._noPostalSent = true; this.track('no_postal'); }
          } else if (priceUnreliable) this.track('no_price', { reason: lane.excluded ? 'excluded_region' : 'size_or_input' });
          else this.track('price_shown', { above_cap: this.priceMap ? s_cents_above(this) : false });
        }, 1500);

        if (priceUnreliable) {
          this.$('each').innerHTML = '—<small>' + this.cur() + '</small>';
          this.$('each-usd').textContent = '';
          if (this.$('wt')) this.$('wt').textContent = '—';
          this.$('total').textContent = '—';
          this.$('lane').textContent = '';
          this.$('assure').textContent = '';
          this.$('spec').value = this.$('desc').textContent + ' | qty ' + q + ' | no instant price';
        } else {
          const shown = this.shownCents(this.state.cents) / 100;
          const shownEach = q ? shown / q : 0;
          const cur = this.cur();
          this.$('each').innerHTML = this.money(shownEach) + '<small>' + cur + '</small>';
          // Owner decision 2026-10-06: no second-currency line under the price.
          this.$('each-usd').textContent = '';
          if (this.$('wt')) this.$('wt').textContent = lb < 1 ? Math.round(lb * 16) + ' oz' : lb.toFixed(1) + ' lb';
          this.$('total').textContent = this.money(shown) + ' ' + cur;
          const shipsAs = 'ships as ' + (boxes.length > 1 ? boxes.length + ' boxes, ' : 'a ') + this.CLS_LABEL[cls] + '.';
          if (lane.country === 'US') {
            this.$('lane').textContent = 'Delivered price to ' + lane.label + '. Shipping, duties and import fees are included, so there is nothing to pay on arrival. It ' + shipsAs;
            this.$('assure').textContent = 'Shipping included · Duties and import fees paid · Nothing to pay at delivery';
          } else {
            this.$('lane').textContent = 'Delivery to ' + lane.label + ' included · ' + shipsAs;
            this.$('assure').textContent = 'Shipping included';
          }
          this.$('spec').value =
            this.$('desc').textContent + ' | qty ' + q + ' | ship to ' + lane.label + ' | ' + this.money(shownEach) + ' each, ' + this.money(shown) + ' total ' + cur + ' delivered' + (this.usd ? ' (' + this.money(price) + ' CAD)' : '') + ' (calculator)';
        }

        const warnEl = this.$('warn');
        warnEl.textContent = warn;
        warnEl.style.display = warn ? 'block' : 'none';

        this.preview(L, W);
        this.updateBuyState();
      }

      preview(L, W) {
        const box = this.$('piece');
        const maxW = 300;
        const maxH = 156;
        const s = Math.min(maxW / Math.max(L, 1), maxH / Math.max(W, 1));
        box.style.width = Math.max(20, L * s) + 'px';
        box.style.height = Math.max(20, W * s) + 'px';
        box.style.borderRadius = this.shape === 'circle' ? '50%' : '2px';
        this.$('dim-w').textContent = this.fmt(L);
        this.$('dim-h').textContent = this.shape === 'circle' ? '' : this.fmt(W);
      }
    }
  );
}
